<template>
  <b-col
    class="form-box card-data-block"
    :class="customClass"
  >
    <div class="structure">
      <b-row>
        <b-col
          :class="{ 'highlight': hasPatientObservationsDiff }"
        >
          <div class="d-flex">
            <b-form-checkbox
              v-if="showPatientObservationsCheckbox"
              v-model="observations.selected"
              :unchecked-value="null"
            />
            <span class="structure__heading"><i
              class="far fa-comment-lines mr-2"
              aria-hidden="true"
            />{{ $t('global.observations') }}</span>
          </div>
          <h4
            :class="{ 'item-selected': setItemSelectedClassToPatientObservations }"
            class="collapsable-card-title inside"
          >
            {{ patient.notes && patient.notes.text ? patient.notes.text : '-' }}
          </h4>
        </b-col>
      </b-row>
    </div>
  </b-col>
</template>

<script>
export default {
    name: 'PatientObservationsCard',
    props: {
        patient: { type: Object, default: null },
        customClass: { type: Array },
        patientDataDiff: { type: Object },
        integrationPatient: { type: Boolean },
        localPatient: { type: Boolean },
        continueWithCaseCreation: { type: Boolean, default: false }
    },
    data() {
        return {
            observations: {}
        }
    },
    computed: {
        showPatientObservationsCheckbox() {
            let showCheckbox = this.integrationPatient
            if (this.continueWithCaseCreation) {
                showCheckbox = showCheckbox && this.hasPatientObservationsDiff
            }
            return showCheckbox
        },

        setItemSelectedClassToPatientObservations() {
            return this.observations.selected &&
                this.integrationPatient &&
                this.hasPatientObservationsDiff
        },

        patientNotes() {
            return this.patient.notes
        },
        duplicatedPatientNotes() {
            return this.patientDataDiff.notes
        },
        hasPatientObservationsDiff() {
            let hasDiff = null
            if (!this.patientDataDiff.notes) {
                hasDiff = this.patientDataDiff.notes === null
            } else {
                hasDiff = this.localPatient
                    ? this.patient.notes?.text !== this.patientDataDiff.notes?.text : true
            }
            return hasDiff
        }
    },
    mounted() {
        this.initializePatientObservationsFields()
    },
    methods: {
        initializePatientObservationsFields() {
            this.observations = {
                selected: this.hasPatientObservationsDiff,
                value: this.patient.notes?.text ?? null
            }
        }
    }
}
</script>

<style scoped>

</style>
